// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOfficePermission-__AccessBackOfficePermission____Dv4T","container-subs":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOfficePermission-__AccessBackOfficePermission___35ose","single-submenu":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOfficePermission-__AccessBackOfficePermission___NPrAG","checkbox-disable":"app-pages-Employees-Role-RoleDetail-RoleForm-AccessBackOfficePermission-__AccessBackOfficePermission___xbXsy"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessBackOfficePermission/AccessBackOfficePermission.css
// module id = 830
// module chunks = 0